const features = [
    {
        title: 'Dijital QR menü',
        desc: 'Şube bazlı menü, görseller, fiyatlar ve çoklu dil hazırlığına uygun yapı.'
    },
    {
        title: 'Kampanya yönetimi',
        desc: 'İndirim, kombinasyon, adet indirimi, “Al Kazan” ve zaman / gün bazlı kampanya planları.'
    },
    {
        title: 'Oylama kampanyaları',
        desc: 'Misafir oylaması, kazanan ürüne özel kampanya süresi ve süreli indirim entegrasyonu.'
    },
    {
        title: 'Banner & hikâyeler',
        desc: 'Üst alan banner’ları ve tam ekran hikâye akışı ile kampanya ve duyuru vitrini.'
    },
    {
        title: 'Arama & analitik',
        desc: 'Menü içi arama, tıklama / görüntülenme istatistikleri ve arama raporları.'
    },
    {
        title: 'Mesaj kutusu',
        desc: 'Misafirlerden gelen mesajları panelden yönetme ve yanıtlama.'
    },
    {
        title: 'Tema & tipografi',
        desc: 'Renkler, fontlar, navbar ve kategori görünümleri ile markanıza özel arayüz.'
    },
    {
        title: 'Şube yönetimi',
        desc: 'Birden fazla lokasyon; menü ve kampanyaları şubeye göre özelleştirme.'
    },
    {
        title: 'Ürün zenginliği',
        desc: 'Çoklu görsel, etiketler, beğeni / beğenmeme ve ürün detayında kampanya gösterimi.'
    },
    {
        title: 'Mobil öncelikli',
        desc: 'QR ile açılan tam ekran deneyim; hızlı yükleme ve dokunmatik odaklı arayüz.'
    }
];

export default function ZehumaPortalFeatures() {
    return (
        <div className="px-4 py-12 sm:py-16">
            <div className="mx-auto max-w-4xl">
                <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Özellikler</h1>
                <p className="mt-3 text-lg text-slate-600">
                    Zehuma QR Menü ile işletmenize kazandırdığımız başlıca yetenekler.
                </p>

                <ul className="mt-10 grid gap-4 sm:grid-cols-2">
                    {features.map((f) => (
                        <li
                            key={f.title}
                            className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-violet-200 hover:shadow-md"
                        >
                            <h2 className="text-base font-bold text-slate-900">{f.title}</h2>
                            <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.desc}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
